module.exports = "/images/jo.svg?33a15f76a225638b0ca5e7b615238700";